// === PRODUCT PAGE VARIANT SORTER ===
// Sorterar storlekar i stigande ordning och väljer alltid minsta tillgängliga variant

const debug = false;
const fieldsetSelector = 'fieldset.js.product-form__input';
const containerSelector = '#MainContent .product__info-container';

function log(...args) {
  if (debug) console.log('[Variant Sort]', ...args);
}

function logError(...args) {
  console.error('[Variant Sort ERROR]', ...args);
}

function sortFieldset(container) {
  const fieldset = container.querySelector(fieldsetSelector);
  if (!fieldset) return false;

  const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
  const labels = Array.from(fieldset.querySelectorAll('label'));

  if (inputs.length !== labels.length || inputs.length === 0) return false;

  const pairs = inputs.map((input, index) => {
    const label = labels[index];
    const text = (label.textContent || '').trim();
    const match = text.match(/(\d+)\s*ml/i);
    const value = match ? parseInt(match[1], 10) : 99999;
    const available = !input.disabled;

    return {
      value,
      input,
      label,
      available
    };
  });

  const hasMlValues = pairs.some(pair => pair.value !== 99999);
  if (!hasMlValues) {
    log('No ml-based options found, skipping sort');
    return false;
  }

  // Sortera stigande: 30 -> 50 -> 100
  pairs.sort((a, b) => a.value - b.value);

  // Lägg tillbaka i sorterad ordning
  pairs.forEach(pair => {
    fieldset.appendChild(pair.input);
    fieldset.appendChild(pair.label);
  });

  // Välj alltid minsta tillgängliga variant
  const firstAvailable = pairs.find(pair => pair.available) || null;
  if (!firstAvailable) {
    log('No available variant found');
    return true;
  }

  // Avmarkera alla först för att undvika att temat lämnar fel variant vald
  pairs.forEach(pair => {
    pair.input.checked = false;
  });

  // Markera rätt variant och trigga temat att uppdatera pris/lager
  firstAvailable.input.checked = true;
  firstAvailable.input.dispatchEvent(new Event('change', { bubbles: true }));

  log(`Selected smallest available variant: ${firstAvailable.value} ml`);
  log('✅ Product page variants sorted');

  return true;
}

function sortProductPage(retry = 0) {
  const container = document.querySelector(containerSelector);

  if (!container) {
    if (retry < 8) {
      setTimeout(() => sortProductPage(retry + 1), 100);
    } else {
      logError('Product container not found after retries');
    }
    return;
  }

  if (container.dataset.productSorted === 'true') {
    log('Product already sorted');
    return;
  }

  requestAnimationFrame(() => {
    const ok = sortFieldset(container);
    if (ok) {
      container.dataset.productSorted = 'true';
    }
  });
}

window.addEventListener('DOMContentLoaded', () => {
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    console.log('🔹 Variant Sorter: SKIPPING in Theme Editor (designMode)');
    return;
  }

  if (document.body.classList.contains('template-product')) {
    console.log('🔹 Product page detected — sorting variants...');
    sortProductPage();
  }
});










(function () {
  // Kör bara på startsidan
  if (!document.body.classList.contains('template-index')) return;

  function runAirReviewsStarsFix() {
    if (!window.AIR_REVIEWS || !window.airReviewDisplayManager) return;

    // Säkerställ att AirReviews kör "collection"-logik även på index
    window.AIR_REVIEWS.template = 'collection';

    // Idempotent: ta bort extra widgets och ev. gamla wrappers
    document.querySelectorAll('.card-wrapper, .card, article, li.grid__item').forEach(card => {
      const widgets = card.querySelectorAll('.AirReviews-Widget.AirReviews-Widget--Stars');
      if (widgets.length > 1) [...widgets].slice(1).forEach(el => el.remove());
    });

    document.querySelectorAll('.AirReviews-Widget.AirReviews-Widget--Stars .AirReviews-StarRatingWrapper')
      .forEach(el => el.remove());

    // Rendera stjärnor
    try { window.airReviewDisplayManager.initialize(); } catch (e) {}
    try { window.airReviewDisplayManager.insertReviewStarRating(); } catch (e) {}
  }

  // Kör efter att sidan laddat + en extra gång för safety (Shopify/sections kan vara sena)
  window.addEventListener('load', runAirReviewsStarsFix);
  setTimeout(runAirReviewsStarsFix, 800);
})();

